import { render } from "./PantriesKitchenModule.vue?vue&type=template&id=0f7e1784&scoped=true"
import script from "./PantriesKitchenModule.vue?vue&type=script&lang=js"
export * from "./PantriesKitchenModule.vue?vue&type=script&lang=js"

import "./PantriesKitchenModule.vue?vue&type=style&index=0&id=0f7e1784&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f7e1784"

export default script